import { KnownAction, GET_DASHBOARD_SERVICES, SHOW_LOADER, DashboardService } from "./types";
import { AppThunkAction } from "..";
import * as httpClient from "../../util/httpClient";
import { idfServiceIds, ezsServiceIds } from "../../config/UserServicesList";
import { getAllTUServiceWithLabel } from "../service";
import { getCatalogProducts } from "../loginService/actions"; 
import { TUServiceAction, RECEIVE_ALL_TU_SEVICES, REQUEST_ALL_TU_SEVICES } from "./types";
import { GetUserDashboardStatus, GET_USER_DASHBOARD_STATUS } from "./types";

export const actionCreators = {
    getDashboardServiceData:
        (isAlertUpdate: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const state = getState();

            const isYodleeServicesActive = () => {
                let isServiceActive = false;
                const yodleeServiceList = [idfServiceIds.bankAndCreditCardActivity, ezsServiceIds.financialTransactionMonitoring];
                const userServices = state?.loggedInUser?.userServiceDetails?.userServices;
                for (const id of yodleeServiceList) {
                    const service = userServices?.find((it) => it.serviceCode === id && it.active);
                    if (service) {
                        isServiceActive = true;
                        break;
                    }
                }
                return isServiceActive;
            };

            if (
                isAlertUpdate ||
                (state.dashboardServiceState && state.dashboardServiceState.dashboardServices != null && state.dashboardServiceState.dashboardServices.length < 1)
            ) {
                dispatch({ type: SHOW_LOADER, isLoading: true });
                httpClient
                    .sendRequest("GET", `web/dashboard/GetDashboardService`)
                    .then((serviceGroupData) => {
                        if (serviceGroupData != null) {
                            getCatalogProducts(dispatch, state);

                            serviceGroupData.forEach(function (data: DashboardService) {
                                data.categoryUrl = navigationUrl(data.categoryName);
                                data.categoryIconClass =
                                    data.categoryName === "Identity"
                                        ? "user-shield"
                                        : data.categoryName === "Credit"
                                        ? "tachometer-alt"
                                        : data.categoryName === "Financial"
                                        ? "coins"
                                        : data.categoryName === "Social"
                                        ? "users"
                                        : data.categoryName === "Mobile Attack"
                                        ? "mobile"
                                        : data.categoryName === "Employees"
                                        ? "user-friends"
                                        : "";
                                data.categoryIconClass = data.categoryText === "Upgrade" ? data.categoryIconClass + "-inverse" : data.categoryIconClass;
                            });
                        }
                        dispatch({ type: GET_DASHBOARD_SERVICES, dashboardServices: serviceGroupData });
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    })
                    .catch(function (error) {
                        const temp = error;
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    });
            }

            const navigationUrl = (categoryName?: string) => {
                // data.categoryName == "Identity" ? "/identity-vault" : data.categoryName == "Credit" ? "/credit/score" : data.categoryName == "Financial" ? "/transactions" : data.categoryName == "Social" ? "/identity-vault" : data.categoryName == "Mobile Attack" ? "/dashboard" : data.categoryName == "Employees" ? "/dashboard" : "#";

                let navigationUrl = "#";
                if (categoryName === "Identity") {
                    navigationUrl = "/identity-vault";
                } else if (categoryName === "Credit") {
                    navigationUrl = "/credit/score";
                } else if (categoryName === "Financial") {
                    navigationUrl = "/transactions";
                    if (!isYodleeServicesActive()) {
                        navigationUrl = "/monitoring";
                    }
                } else if (categoryName === "Social") {
                    navigationUrl = "/identity-vault";
                } else if (categoryName === "Mobile Attack") {
                    navigationUrl = "/dashboard";
                } else if (categoryName === "Employees") {
                    navigationUrl = "/dashboard";
                }

                return navigationUrl;
            };
        },
    updateDashboardServiceData:
        (serviceCategory: string): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const state = getState();
            const dashboardServices: any = state.dashboardServiceState && state.dashboardServiceState.dashboardServices;
            if (dashboardServices.length > 0) {
                const updatedData = dashboardServices.map((service: any) => {
                    if (service.categoryName === serviceCategory) {
                        service.newAlertCount = service.newAlertCount - 1;
                        return service;
                    } else {
                        return service;
                    }
                });
                dispatch({ type: GET_DASHBOARD_SERVICES, dashboardServices: updatedData });
            }
        },

    getAllTUServiceWithLabel:
        (): AppThunkAction<TUServiceAction> =>
            (dispatch, getState) => {
                const appSate = getState();
                if (appSate && appSate.tuServicesState && appSate.tuServicesState.tuServices) {
                    return;
                }

                getAllTUServiceWithLabel()
                    .then((data) => {
                        if (data && !data["hasError"] && data["productCode"]) {
                            dispatch({ type: RECEIVE_ALL_TU_SEVICES, tuServices: data["productCode"] });
                        } else {
                            dispatch({ type: RECEIVE_ALL_TU_SEVICES });
                        }
                    })
                    .catch((error) => {
                        dispatch({ type: RECEIVE_ALL_TU_SEVICES });
                    });
                dispatch({ type: REQUEST_ALL_TU_SEVICES });
            },

    setUserDashboardStatus:
        (userDashboardstatus: string): AppThunkAction<GetUserDashboardStatus> =>
            (dispatch) => {
                dispatch({
                    type: GET_USER_DASHBOARD_STATUS,
                    userDashboardstatus: userDashboardstatus,                 
                });
            },
};
